import React from 'react';
import { Link } from 'react-router-dom';
import { Footer } from '../components/Footer';
import { Helmet } from 'react-helmet-async';
export function TermsPage() {
  return <>
      <Helmet data-id="element-437">
        <title data-id="element-438">Terms of Service - Fifth Door</title>
        <meta name="description" content="Fifth Door Terms of Service." data-id="element-439" />
        <link rel="preconnect" href="https://fonts.googleapis.com" data-id="element-440" />
        <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" data-id="element-441" />
        <link href="https://fonts.googleapis.com/css2?family=Bungee&family=Bricolage+Grotesque:wght@400;500;600;700&family=Instrument+Sans:wght@400;500;600;700&display=swap" rel="stylesheet" data-id="element-442" />
      </Helmet>

      <main className="w-full relative isolate overflow-x-hidden min-h-screen" style={{
      backgroundColor: '#074030'
    }} data-id="element-443">
        <div className="absolute inset-0 pointer-events-none -z-10" style={{
        backgroundImage: `
              linear-gradient(to right, rgba(255, 255, 255, 0.1) 1px, transparent 1px),
              linear-gradient(to bottom, rgba(255, 255, 255, 0.1) 1px, transparent 1px)
            `,
        backgroundSize: '30px 30px',
        backgroundPosition: '0 0'
      }} data-id="element-444" />
        <div className="absolute inset-0 pointer-events-none -z-10" style={{
        backgroundImage: 'url(https://cdn.magicpatterns.com/uploads/bonQpX7FQKEhKvnQfRNJtT/noise-background.png)',
        backgroundRepeat: 'repeat',
        backgroundSize: '200px 200px',
        opacity: 0.24
      }} data-id="element-445" />

        <div className="absolute top-8 left-8 z-20" data-id="element-446">
          <Link to="/" className="flex items-center gap-3" data-id="element-447">
            <img src="https://cdn.magicpatterns.com/uploads/8dB8M4GqHB66FgPhzt2tyW/Group_44.png" alt="Fifth Door Logo" className="h-8 w-auto object-contain brightness-0 invert" data-id="element-448" />
            <span className="text-white text-lg" style={{
            fontFamily: 'Bungee, sans-serif'
          }} data-id="element-449">
              FIFTH DOOR
            </span>
          </Link>
        </div>

        <div className="relative z-10 px-6 py-20 md:py-32 max-w-4xl mx-auto" data-id="element-450">
          <h1 className="text-[50px] md:text-[74px] mb-8 text-center" style={{
          fontFamily: 'Bungee, sans-serif',
          color: 'white',
          lineHeight: '1.1'
        }} data-id="element-451">
            TERMS OF SERVICE
          </h1>
          <div className="text-white/70 leading-relaxed text-lg space-y-6" style={{
          fontFamily: "'Instrument Sans', sans-serif"
        }} data-id="element-452">
            <p className="font-bold" data-id="element-453">Last Updated: April 13, 2026</p>

            <p data-id="element-454">
              Please read these Terms of Service (the "Terms") and our Privacy
              Notice (https://fifthdoor.com/privacy) ("Privacy Notice")
              carefully because they govern your: (i) use of the website located
              at: https://fifthdoor.com/ (the "Site"), (ii) use of our platform
              that enables the creation of mini-games with no coding knowledge
              required and which are then hosted on the Site; (iii) playing of
              the mini-games hosted on the Site; and (iv) use of the
              corresponding mobile application ("App") which may be offered by
              Fifth Door, Inc. ("Fifth Door"). To make these Terms easier to
              read, the Site, our services and App are collectively called the
              "Services."
            </p>

            <p className="font-bold uppercase" data-id="element-455">
              IMPORTANT NOTICE REGARDING ARBITRATION FOR U.S. CUSTOMERS: WHEN
              YOU AGREE TO THESE TERMS YOU ARE AGREEING (WITH LIMITED EXCEPTION)
              TO RESOLVE ANY DISPUTE BETWEEN YOU AND FIFTH DOOR THROUGH BINDING,
              INDIVIDUAL ARBITRATION RATHER THAN IN COURT. PLEASE REVIEW
              CAREFULLY SECTION 17 "DISPUTE RESOLUTION" BELOW FOR DETAILS
              REGARDING ARBITRATION.
            </p>

            <p data-id="element-456">
              <strong data-id="element-457">Agreement to Terms.</strong> By using our Services, you
              agree to be bound by these Terms. If you don't agree to be bound
              by these Terms, do not use the Services.
            </p>

            <p data-id="element-458">
              <strong data-id="element-459">Privacy Notice.</strong> Please review our Privacy Notice,
              which also governs your use of the Services, for information on
              how we collect, use and share your information.
            </p>

            <p data-id="element-460">
              <strong data-id="element-461">Changes to these Terms or the Services.</strong> We may
              update the Terms from time to time in our sole discretion. If we
              do, we'll let you know by posting the updated Terms on the Site,
              to the App and/or may also send other communications. It's
              important that you review the Terms whenever we update them or you
              use the Services. If you continue to use the Services after we
              have posted updated Terms it means that you accept and agree to
              the changes. If you don't agree to be bound by the changes, you
              may not use the Services anymore. Because our Services are
              evolving over time we may change or discontinue all or any part of
              the Services, at any time and without notice, at our sole
              discretion.
            </p>

            <p data-id="element-462">
              <strong data-id="element-463">Who May Use the Services?</strong> You may use the
              Services only if you are 13 years or older and capable of forming
              a binding contract with Fifth Door, and not otherwise barred from
              using the Services under applicable law.
            </p>

            <p data-id="element-464">
              <strong data-id="element-465">Feedback.</strong> We appreciate feedback, comments,
              ideas, proposals and suggestions for improvements to the Services
              ("Feedback"). If you choose to submit Feedback, you agree that we
              are free to use it without any restriction or compensation to you.
            </p>

            <p className="font-bold text-xl mt-8" data-id="element-466">
              Use of Services: Free and Paid For Services.
            </p>

            <p data-id="element-467">
              <strong data-id="element-468">Registration and Your Information.</strong> In order to
              use the Services, you may have the ability to create an account or
              similar profile to use ("Account"). We may also allow you to
              create an Account through your account with certain third-party
              services such as Facebook, Apple, Google or Twitter (each, an "SNS
              Account"). If you choose the SNS Account option, we'll create your
              Account by extracting from your SNS Account certain personal
              information such as your name and email address and other personal
              information that your privacy settings on the SNS Account permit
              us to access. You agree that you won't misrepresent your identity,
              use any other person's image, likeness or identity, or otherwise
              provide any deceptive or misleading profile information or images
              in connection with the creation and use of your Account.
            </p>

            <p data-id="element-469">
              <strong data-id="element-470">Accuracy of Account Information.</strong> It's important
              that you provide us with accurate, complete and up-to-date
              information for your Account, and you agree to update such
              information to keep it accurate, complete and up to date. If you
              don't, we might have to suspend or terminate your Account. You
              agree that you won't disclose your Account password to anyone and
              will use all reasonable means to secure your Account password and
              associated login credentials. You agree to notify us immediately
              of any unauthorized use of your Account, and you agree not to
              share your Account with any other person or otherwise permit any
              other person to use your Account, even on a temporary basis.
              You're responsible for all activities that occur under your
              Account, whether or not you know about them. We may take actions
              we deem reasonably necessary to prevent fraud and abuse, including
              placing restrictions on user accounts or on the amount of content
              that can be accessed from the Platform at any one time.
            </p>

            <p data-id="element-471">
              <strong data-id="element-472">Free; Paid Versions.</strong> We may offer some of the
              Services for free and others that require payment. If you use the
              Services that we offer for free, you may only use the Services and
              any User Content you create for your personal, non-commercial
              purposes. Any commercial use of the Services or User Content
              created using the free version, including internal business use,
              distribution, sale, or other monetization, is strictly prohibited.
              For the pricing terms for the Services for which we charge
              services, please visit our pricing page, as may be posted and
              updated from time to time at: https://fifthdoor.com/pricing.
            </p>

            <p data-id="element-473">
              <strong data-id="element-474">One-Time Payments and Subscriptions.</strong> If we
              require payment of a fee for use of the Services (or certain
              portions thereof) you agree to pay such fees. We may give you the
              option of making one-time payments on a transaction-by-transaction
              basis ("One-Time Payment(s)") or purchasing a subscription
              ("Subscription") for such use. Whether you make a One-Time
              Payment(s) or purchase a Subscription (each, a "Transaction"), you
              expressly authorize us (or our third-party payment processor) to
              charge you for such Transaction. We may ask you to supply
              additional information relevant to your Transaction, including
              your credit card number, the expiration date of your credit card
              and your email and postal addresses for billing and notification
              (such information, "Payment Information"). You represent and
              warrant that you have the legal right to use all payment method(s)
              represented by any such Payment Information. When you initiate a
              Transaction, you authorize us to provide your Payment Information
              to third parties so we can complete your Transaction and to charge
              your payment method for the type of Transaction you have selected
              (plus any applicable taxes and other charges). You may need to
              provide additional information to verify your identity before
              completing your Transaction (such information is included within
              the definition of Payment Information). By initiating a
              Transaction, you agree to the pricing, payment and billing
              policies applicable to such fees and charges, as posted or
              otherwise communicated to you. All payments for Transactions are
              non-refundable and non-transferable except as expressly provided
              in these Terms. All fees and applicable taxes, if any, are payable
              in United States dollars.
            </p>

            <p data-id="element-475">
              <strong data-id="element-476">Subscriptions.</strong> If you purchase a Subscription,
              you will be charged on a monthly or annual basis for the
              Subscription fees, plus any applicable taxes, and other charges
              ("Subscription Fee"), at the beginning of your Subscription and
              each year thereafter, at the then-current Subscription Fee. BY
              PURCHASING A SUBSCRIPTION, YOU AUTHORIZE FIFTH DOOR TO INITIATE
              RECURRING NON-REFUNDABLE PAYMENTS AS SET FORTH BELOW. If you
              purchase a Subscription, we (or our third-party payment processor)
              will automatically charge you each year on the anniversary of the
              commencement of your Subscription, using the Payment Information
              you have provided until you cancel your Subscription. If you
              purchase an annual subscription, no less than thirty (30) days and
              no more than forty (40) days before your Subscription term ends,
              or otherwise in accordance with applicable law, Fifth Door will
              send you a reminder with the then-current Subscription Fee. By
              agreeing to these Terms and electing to purchase a Subscription,
              you acknowledge that your Subscription has recurring payment
              features and you accept responsibility for all recurring payment
              obligations prior to cancellation of your Subscription by you or
              Fifth Door. Your Subscription continues until cancelled by you or
              we terminate your access to or use of the Services or Subscription
              in accordance with these Terms.
            </p>

            <p data-id="element-477">
              <strong data-id="element-478">Cancelling One-Time Payment or Subscription.</strong> YOUR
              PURCHASE IS FINAL AND YOU WILL NOT BE ABLE TO CANCEL THE PURCHASE
              AND/OR RECEIVE A REFUND OF YOUR ONE-TIME PAYMENT OR SUBSCRIPTION
              FEE AT ANY TIME. But if something unexpected happens in the course
              of completing a Transaction, we reserve the right to cancel your
              Transaction for any reason; if we cancel your Transaction we'll
              refund any payment you have already remitted to us for such
              Transaction. Without limiting the foregoing, you may cancel your
              Subscription at any time, but please note that such cancellation
              will be effective at the end of the then-current Subscription
              period. EXCEPT AS SET FORTH ABOVE WITH RESPECT TO YOUR INITIAL
              SUBSCRIPTION PURCHASE, YOU WILL NOT RECEIVE A REFUND OF ANY
              PORTION OF THE SUBSCRIPTION FEE PAID FOR THE THEN CURRENT
              SUBSCRIPTION PERIOD AT THE TIME OF CANCELLATION. To cancel, you
              can send an email to accounts@fifthdoor.com. You will be
              responsible for all Subscription Fees (plus any applicable taxes
              and other charges) incurred for the then-current Subscription
              period. If you cancel, your right to use the Services will
              continue until the end of your then current Subscription period
              and will then terminate without further charges.
            </p>

            <p className="font-bold text-xl mt-8" data-id="element-479">Your Content / Mini-games.</p>

            <p data-id="element-480">
              <strong data-id="element-481">Posting Content.</strong> Our Services may allow you to
              generate, store or share mini-games and other content such as text
              (in posts or communications with others), files, documents,
              graphics, images, music, software, audio and video. Anything
              (other than Feedback) that you post or otherwise make available
              through the Services is referred to as "User Content". Fifth Door
              does not claim any ownership rights in any User Content and
              nothing in these Terms will be deemed to restrict any rights that
              you may have to your User Content, except as set forth below.
            </p>

            <p data-id="element-482">
              <strong data-id="element-483">Permissions to Your User Content.</strong> By making any
              User Content available through the Services you hereby grant to
              Fifth Door a non-exclusive, transferable, worldwide, royalty-free
              license, with the right to sublicense, to use, copy, modify,
              create derivative works based upon, distribute, publicly display,
              and publicly perform your User Content in connection with
              operating and providing the Services. You further acknowledge and
              agree that Fifth Door may combine or aggregate User Content with
              data from other users to create aggregated and/or deidentified so
              that it cannot reasonably be used to identify an individual person
              or organization ("Anonymized Data"), and may retain, use,
              disclose, license, sell, or otherwise provide such Anonymized Data
              to third parties, including but not limited to artificial
              intelligence research organizations and commercial model
              developers, for any purpose, including training, developing,
              evaluating, or validating machine learning models. Fifth Door may
              transfer User Content, Anonymized Data or telemetry, logs, model
              traces, and other technical or analytical information generated by
              your use of the Services to its own or third-party AI providers
              and research partners for these purposes. You waive any claim to
              royalties or other remuneration in connection with such use.
            </p>

            <p data-id="element-484">
              <strong data-id="element-485">Your Responsibility for User Content.</strong> You are
              solely responsible for all your User Content. You represent and
              warrant that you have (and will have) all rights that are
              necessary to grant us the license rights in your User Content
              under these Terms. You represent and warrant that neither your
              User Content, nor your use and provision of your User Content to
              be made available through the Services, nor any use of your User
              Content by Fifth Door on or through the Services will infringe,
              misappropriate or violate a third party's intellectual property
              rights, or rights of publicity or privacy, or result in the
              violation of any applicable law or regulation.
            </p>

            <p data-id="element-486">
              <strong data-id="element-487">Removal of User Content.</strong> You may allow you to
              remove your User Content by specifically deleting it, or in the
              case of any of your mini-games, unpublishing the game for public
              view. You should know that in certain instances, some of your User
              Content (such as posts or comments you make) may not be completely
              removed and copies of your User Content may continue to exist on
              the Services. To the maximum extent permitted by law, we are not
              responsible or liable for the removal or deletion of (or the
              failure to remove or delete) any of your User Content.
            </p>

            <p data-id="element-488">
              <strong data-id="element-489">AI Technology Disclosure.</strong> You acknowledge that
              certain features of the Services (including the creation of
              min-games) may utilize artificial intelligence (AI) technologies,
              including but not limited to application programming interfaces
              (APIs) provided by third-party AI providers. These AI technologies
              may be used to generate, process, or analyze content within the
              Services. Due to the probabilistic nature of machine learning and
              AI, outputs generated by these technologies may be inaccurate,
              incomplete, or otherwise unreliable. Fifth Door makes no
              representations or warranties as to the accuracy, completeness, or
              suitability of any AI-generated outputs. You are solely
              responsible for reviewing and verifying any AI-generated content
              before relying on or using it, and you should use human review
              prior to any such use.
            </p>

            <p data-id="element-490">
              <strong data-id="element-491">Fifth Door's Intellectual Property.</strong> We may make
              available through the Services content that is subject to
              intellectual property rights. We retain all rights to that
              content.
            </p>

            <p data-id="element-492">
              <strong data-id="element-493">
                General Prohibitions and Fifth Door's Enforcement Rights.
              </strong>{' '}
              You agree not to do any of the following:
            </p>

            <ul className="list-disc pl-6 space-y-2" data-id="element-494">
              <li data-id="element-495">
                Violate any of our community guidelines that we publish, or
                post, upload, publish, submit or transmit any User Content
                (including any mini-games) that: (i) infringes, misappropriates
                or violates a third party's patent, copyright, trademark, trade
                secret, moral rights or other intellectual property rights, or
                rights of publicity or privacy; (ii) violates, or encourages any
                conduct that would violate, any applicable law or regulation or
                would give rise to civil liability; (iii) is fraudulent, false,
                misleading or deceptive; (iv) is defamatory, obscene,
                pornographic, vulgar or offensive; (v) promotes discrimination,
                bigotry, racism, hatred, harassment or harm against any
                individual or group; (vi) is violent or threatening or promotes
                violence or actions that are threatening to any person or
                entity; or (vii) promotes illegal or harmful activities or
                substances;
              </li>
              <li data-id="element-496">
                Use, display, mirror or frame the Services or any individual
                element within the Services, Fifth Door's name, any Fifth Door
                trademark, logo or other proprietary information, or the layout
                and design of any page or form contained on a page, without
                Fifth Door's express written consent;
              </li>
              <li data-id="element-497">
                Access, tamper with, or use non-public areas of the Services,
                Fifth Door's computer systems, or the technical delivery systems
                of Fifth Door's providers;
              </li>
              <li data-id="element-498">
                Attempt to probe, scan or test the vulnerability of any Fifth
                Door system or network or breach any security or authentication
                measures;
              </li>
              <li data-id="element-499">
                Avoid, bypass, remove, deactivate, impair, descramble or
                otherwise circumvent any technological measure implemented by
                Fifth Door or any of Fifth Door's providers or any other third
                party (including another user) to protect the Services;
              </li>
              <li data-id="element-500">
                Attempt to access or search the Services or download content
                from the Services using any engine, software, tool, agent,
                device or mechanism (including spiders, robots, crawlers, data
                mining tools or the like) other than the software and/or search
                agents provided by Fifth Door or other generally available
                third-party web browsers;
              </li>
              <li data-id="element-501">
                Send any unsolicited or unauthorized advertising, promotional
                materials, email, junk mail, spam, chain letters or other form
                of solicitation;
              </li>
              <li data-id="element-502">
                Use any meta tags or other hidden text or metadata utilizing a
                Fifth Door trademark, logo URL or product name without Fifth
                Door's express written consent;
              </li>
              <li data-id="element-503">
                Use the Services, or any portion thereof, for any commercial
                purpose or for the benefit of any third party or in any manner
                not permitted by these Terms;
              </li>
              <li data-id="element-504">
                Attempt to decipher, decompile, disassemble or reverse engineer
                any of the software used to provide the Services;
              </li>
              <li data-id="element-505">
                Interfere with, or attempt to interfere with, the access of any
                user, host or network, including, without limitation, sending a
                virus, overloading, flooding, spamming, or mail-bombing the
                Services;
              </li>
              <li data-id="element-506">
                Collect or store any personally identifiable information from
                the Services from other users of the Services without their
                express permission;
              </li>
              <li data-id="element-507">
                Impersonate or misrepresent your affiliation with any person or
                entity;
              </li>
              <li data-id="element-508">Violate any applicable law or regulation; or</li>
              <li data-id="element-509">
                Encourage or enable any other individual to do any of the
                foregoing.
              </li>
            </ul>

            <p data-id="element-510">
              Fifth Door is not obligated to monitor access to or use of the
              Services or to review or edit any content. However, we have the
              right to do so for the purpose of operating the Services, to
              ensure compliance with these Terms and to comply with applicable
              law or other legal requirements. We reserve the right, but are not
              obligated, to remove or disable access to any content, including
              User Content (and any of your mini-games hosted on the Services),
              at any time and without notice, including, but not limited to, if
              we, at our sole discretion, consider it objectionable or in
              violation of these Terms. We have the right to investigate
              violations of these Terms or conduct that affects the Services. We
              may also consult and cooperate with law enforcement authorities to
              prosecute users who violate the law.
            </p>

            <p data-id="element-511">
              <strong data-id="element-512">DMCA/Copyright Policy.</strong> Fifth Door respects
              copyright law and expects its users to do the same. It is Fifth
              Door's policy to terminate in appropriate circumstances account
              holders who repeatedly infringe or are believed to be repeatedly
              infringing the rights of copyright holders. Please see Fifth
              Door's Copyright and IP Policy at https://fifthdoor.com/dmca, for
              further information.
            </p>

            <p data-id="element-513">
              <strong data-id="element-514">Links to Third Party Websites or Resources.</strong> The
              Services (including the App) may allow you to access third-party
              websites or other resources. We provide access only as a
              convenience and are not responsible for the content, products or
              services on or available from those resources or links displayed
              on such websites. You acknowledge sole responsibility for and
              assume all risk arising from, your use of any third-party
              resources.
            </p>

            <p data-id="element-515">
              <strong data-id="element-516">Beta Services.</strong> From time to time, Fifth Door may
              make available certain features, services, or functionality
              labeled or designated as alpha, beta, preview, pre-release, or
              similar ("Beta Services"). Beta Services are provided solely for
              evaluation and testing purposes, and may be modified or
              discontinued at Fifth Door's sole discretion. Beta Services are
              provided "AS IS," "AS AVAILABLE," with all faults, and without any
              warranty of any kind, whether express, implied, statutory, or
              otherwise, including any warranties of merchantability, fitness
              for a particular purpose, or non-infringement. Fifth Door does not
              guarantee that Beta Services will be free of defects or errors, or
              that they will become generally available. To the maximum extent
              permitted by law, Fifth Door's total cumulative liability for any
              and all claims arising from or relating to the Beta Services shall
              not exceed fifty dollars ($50).
            </p>

            <p className="font-bold text-xl mt-8" data-id="element-517">Rights and Terms for Apps.</p>

            <p data-id="element-518">
              <strong data-id="element-519">App License.</strong> If you comply with these Terms,
              Fifth Door grants to you a limited non-exclusive, non-transferable
              license, with no right to sublicense, to download and install the
              App, when and if Fifth Door makes such available, on your personal
              computers, mobile handsets, tablets, wearable devices, and/or
              other devices and to run the App solely for your own personal
              non-commercial purposes. Except as expressly permitted in these
              Terms, you may not: (i) copy, modify or create derivative works
              based on the App; (ii) distribute, transfer, sublicense, lease,
              lend or rent the App to any third party; (iii) reverse engineer,
              decompile or disassemble the App (unless applicable law permits,
              despite this limitation); or (iv) make the functionality of the
              App available to multiple users through any means.
            </p>

            <p data-id="element-520">
              <strong data-id="element-521">Additional Information: Apple App Store.</strong> This
              Section 8(b) applies to any App that you acquire from the Apple
              App Store or use on an iOS device. Apple has no obligation to
              furnish any maintenance and support services with respect to the
              App. In the event of any failure of the App to conform to any
              applicable warranty, you may notify Apple, and Apple will refund
              the App purchase price to you (if applicable) and, to the maximum
              extent permitted by applicable law, Apple will have no other
              warranty obligation whatsoever with respect to the App. Apple is
              not responsible for addressing any claims by you or any third
              party relating to the App or your possession and use of it,
              including, but not limited to: (i) product liability claims; (ii)
              any claim that the App fails to conform to any applicable legal or
              regulatory requirement; and (iii) claims arising under consumer
              protection or similar legislation. Apple is not responsible for
              the investigation, defense, settlement and discharge of any
              third-party claim that your possession and use of the App infringe
              that third party's intellectual property rights. Apple and its
              subsidiaries are third-party beneficiaries of these Terms, and
              upon your acceptance of the Terms, Apple will have the right (and
              will be deemed to have accepted the right) to enforce these Terms
              against you as a third-party beneficiary thereof. You represent
              and warrant that (i) you are not located in a country that is
              subject to a U.S. Government embargo, or that has been designated
              by the U.S. Government as a terrorist-supporting country; and (ii)
              you are not listed on any U.S. Government list of prohibited or
              restricted parties. You must also comply with any applicable
              third-party terms of service when using the App.
            </p>

            <p data-id="element-522">
              <strong data-id="element-523">Termination.</strong> We may suspend or terminate your
              access to and use of the Services, including suspending access to
              or terminating your account, at our sole discretion, at any time
              and without notice to you. You may cancel your account at any time
              by sending us an email at accounts@fifthdoor.com. Upon any
              termination, discontinuation or cancellation of the Services or
              your account, the following Sections will survive: 7(b), 7(c),
              7(e), 13, 14, 15, 16, 17, 18 and 19.
            </p>

            <p data-id="element-524">
              <strong data-id="element-525">Warranty Disclaimers.</strong> THE SERVICES ARE PROVIDED
              "AS IS," WITHOUT WARRANTY OF ANY KIND. WITHOUT LIMITING THE
              FOREGOING, WE EXPLICITLY DISCLAIM ANY IMPLIED WARRANTIES OF
              MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, QUIET ENJOYMENT
              AND NON-INFRINGEMENT, AND ANY WARRANTIES ARISING OUT OF COURSE OF
              DEALING OR USAGE OF TRADE. We make no warranty that the Services
              will meet your requirements or be available on an uninterrupted,
              secure, or error-free basis. We make no warranty regarding the
              quality, accuracy, timeliness, truthfulness, completeness or
              reliability of any information or content on the Services.
            </p>

            <p data-id="element-526">
              <strong data-id="element-527">Indemnity.</strong> You will indemnify and hold Fifth Door
              and its officers, directors, employees and agents harmless from
              and against any claims, disputes, demands, liabilities, damages,
              losses, and costs and expenses, including, without limitation,
              reasonable legal and accounting fees, arising out of or in any way
              connected with (a) your access to or use of the Services, (b) your
              User Content, including any claim that your User Content
              infringes, misappropriates, or otherwise violates any third
              party's intellectual property rights, including but not limited to
              copyright, trademark, trade secret, or rights of publicity or
              privacy, or (c) your violation of these Terms.
            </p>

            <p className="font-bold text-xl mt-8" data-id="element-528">Limitation of Liability.</p>

            <p className="uppercase" data-id="element-529">
              TO THE MAXIMUM EXTENT PERMITTED BY LAW, NEITHER Fifth Door NOR ITS
              SERVICE PROVIDERS INVOLVED IN CREATING, PRODUCING, OR DELIVERING
              THE SERVICES WILL BE LIABLE FOR ANY INCIDENTAL, SPECIAL, EXEMPLARY
              OR CONSEQUENTIAL DAMAGES, OR DAMAGES FOR LOST PROFITS, LOST
              REVENUES, LOST SAVINGS, LOST BUSINESS OPPORTUNITY, LOSS OF DATA OR
              GOODWILL, SERVICE INTERRUPTION, COMPUTER DAMAGE OR SYSTEM FAILURE
              OR THE COST OF SUBSTITUTE SERVICES OF ANY KIND ARISING OUT OF OR
              IN CONNECTION WITH THESE TERMS OR FROM THE USE OF OR INABILITY TO
              USE THE SERVICES, WHETHER BASED ON WARRANTY, CONTRACT, TORT
              (INCLUDING NEGLIGENCE), PRODUCT LIABILITY OR ANY OTHER LEGAL
              THEORY, AND WHETHER OR NOT Fifth Door OR ITS SERVICE PROVIDERS
              HAVE BEEN INFORMED OF THE POSSIBILITY OF SUCH DAMAGE, EVEN IF A
              LIMITED REMEDY SET FORTH HEREIN IS FOUND TO HAVE FAILED OF ITS
              ESSENTIAL PURPOSE.
            </p>

            <p className="uppercase" data-id="element-530">
              TO THE MAXIMUM EXTENT PERMITTED BY LAW, IN NO EVENT WILL FIFTH
              DOOR'S TOTAL CUMULATIVE LIABILITY TO YOU ARISING FROM ALL CLAIMS
              UNDER OR RELATED TO THESE TERMS OR FROM THE USE OF OR INABILITY TO
              USE THE SERVICES EXCEED THE AMOUNTS ACTUAL PAID BY YOU OR ARE
              PAYABLE BY YOU TO Fifth Door FOR USE OF THE SERVICES, PROVIDED
              THAT IN NO EVENT WILL Fifth Door'S TOTAL CUMULATIVE LIABILITY FOR
              ALL CLAIMS MADE UNDER OR RELATED TO THIS AGREEMENT EXCEED TWO
              HUNDRED DOLLARS $200.00.
            </p>

            <p className="uppercase" data-id="element-531">
              THE EXCLUSIONS AND LIMITATIONS OF DAMAGES SET FORTH ABOVE ARE
              FUNDAMENTAL ELEMENTS OF THE BASIS OF THE BARGAIN BETWEEN Fifth
              Door AND YOU.
            </p>

            <p data-id="element-532">
              <strong data-id="element-533">Governing Law and Forum Choice.</strong> These Terms and
              any action related thereto will be governed by the Federal
              Arbitration Act, federal arbitration law, and the laws of the
              State of California, without regard to its conflict of laws
              provisions. Except as otherwise expressly set forth in Section 17
              "Dispute Resolution," the exclusive jurisdiction for all Disputes
              (defined below) that you and Fifth Door are not required to
              arbitrate will be the state and federal courts located in the San
              Francisco County, and you and Fifth Door each waive any objection
              to jurisdiction and venue in such courts.
            </p>

            <p className="font-bold text-xl mt-8" data-id="element-534">Dispute Resolution.</p>

            <p data-id="element-535">
              <strong data-id="element-536">Mandatory Arbitration of Disputes.</strong> We each agree
              that any dispute, claim or controversy arising out of or relating
              to these Terms or the breach, termination, enforcement,
              interpretation or validity thereof or the use of the Services
              (collectively, "Disputes") will be resolved solely by binding,
              individual arbitration and not in a class, representative or
              consolidated action or proceeding. You and Fifth Door agree that
              the U.S. Federal Arbitration Act governs the interpretation and
              enforcement of these Terms, and that you and Fifth Door are each
              waiving the right to a trial by jury or to participate in a class
              action. This arbitration provision shall survive termination of
              these Terms.
            </p>

            <p data-id="element-537">
              <strong data-id="element-538">Exceptions.</strong> As limited exceptions to Section
              17(a) above: (i) we both may seek to resolve a Dispute in small
              claims court if it qualifies; and (ii) we each retain the right to
              seek injunctive or other equitable relief from a court to prevent
              (or enjoin) the infringement or misappropriation of our
              intellectual property rights.
            </p>

            <p data-id="element-539">
              <strong data-id="element-540">Conducting Arbitration and Arbitration Rules.</strong> The
              arbitration will be conducted by the American Arbitration
              Association ("AAA") under its Consumer Arbitration Rules (the "AAA
              Rules") then in effect, except as modified by these Terms. The AAA
              Rules are available at www.adr.org or by calling 1-800-778-7879. A
              party who wishes to start arbitration must submit a written Demand
              for Arbitration to AAA and give notice to the other party as
              specified in the AAA Rules. The AAA provides a form Demand for
              Arbitration at www.adr.org.
            </p>

            <p data-id="element-541">
              Any arbitration hearings will take place in the county (or parish)
              where you live, unless we both agree to a different location. The
              parties agree that the arbitrator shall have exclusive authority
              to decide all issues relating to the interpretation,
              applicability, enforceability and scope of this arbitration
              agreement.
            </p>

            <p data-id="element-542">
              <strong data-id="element-543">Arbitration Costs.</strong> Payment of all filing,
              administration and arbitrator fees will be governed by the AAA
              Rules, and we won't seek to recover the administration and
              arbitrator fees we are responsible for paying, unless the
              arbitrator finds your Dispute frivolous. If we prevail in
              arbitration we'll pay all of our attorneys' fees and costs and
              won't seek to recover them from you. If you prevail in arbitration
              you will be entitled to an award of attorneys' fees and expenses
              to the extent provided under applicable law.
            </p>

            <p data-id="element-544">
              <strong data-id="element-545">Injunctive and Declaratory Relief.</strong> Except as
              provided in Section 17(b) above, the arbitrator shall determine
              all issues of liability on the merits of any claim asserted by
              either party and may award declaratory or injunctive relief only
              in favor of the individual party seeking relief and only to the
              extent necessary to provide relief warranted by that party's
              individual claim. To the extent that you or we prevail on a claim
              and seek public injunctive relief (that is, injunctive relief that
              has the primary purpose and effect of prohibiting unlawful acts
              that threaten future injury to the public), the entitlement to and
              extent of such relief must be litigated in a civil court of
              competent jurisdiction and not in arbitration. The parties agree
              that litigation of any issues of public injunctive relief shall be
              stayed pending the outcome of the merits of any individual claims
              in arbitration.
            </p>

            <p data-id="element-546">
              <strong data-id="element-547">Class Action Waiver.</strong> YOU AND FIFTH DOOR AGREE
              THAT EACH MAY BRING CLAIMS AGAINST THE OTHER ONLY IN YOUR OR ITS
              INDIVIDUAL CAPACITY, AND NOT AS A PLAINTIFF OR CLASS MEMBER IN ANY
              PURPORTED CLASS OR REPRESENTATIVE PROCEEDING. Further, if the
              parties' Dispute is resolved through arbitration, the arbitrator
              may not consolidate another person's claims with your claims, and
              may not otherwise preside over any form of a representative or
              class proceeding. If this specific provision is found to be
              unenforceable, then the entirety of this Dispute Resolution
              section shall be null and void.
            </p>

            <p data-id="element-548">
              <strong data-id="element-549">Severability.</strong> With the exception of any of the
              provisions in Section 17(f) of these Terms ("Class Action
              Waiver"), if an arbitrator or court of competent jurisdiction
              decides that any part of these Terms is invalid or unenforceable,
              the other parts of these Terms will still apply.
            </p>

            <p className="font-bold text-xl mt-8" data-id="element-550">General Terms.</p>

            <p data-id="element-551">
              <strong data-id="element-552">Reservation of Rights.</strong> Fifth Door and its
              licensors exclusively own all right, title and interest in and to
              the Services, including all associated intellectual property
              rights. You acknowledge that the Services are protected by
              copyright, trademark, and other laws of the United States and
              foreign countries. You agree not to remove, alter or obscure any
              copyright, trademark, service mark or other proprietary rights
              notices incorporated in or accompanying the Services.
            </p>

            <p data-id="element-553">
              <strong data-id="element-554">Entire Agreement.</strong> These Terms constitute the
              entire and exclusive understanding and agreement between Fifth
              Door and you regarding the Services, and these Terms supersede and
              replace all prior oral or written understandings or agreements
              between Fifth Door and you regarding the Services. If any
              provision of these Terms is held invalid or unenforceable by an
              arbitrator or a court of competent jurisdiction, that provision
              will be enforced to the maximum extent permissible and the other
              provisions of these Terms will remain in full force and effect.
              Except where provided by applicable law in your jurisdiction, you
              may not assign or transfer these Terms, by operation of law or
              otherwise, without Fifth Door's prior written consent. Any attempt
              by you to assign or transfer these Terms absent our consent or
              your statutory right, without such consent, will be null. Fifth
              Door may freely assign or transfer these Terms without
              restriction. Subject to the foregoing, these Terms will bind and
              inure to the benefit of the parties, their successors and
              permitted assigns.
            </p>

            <p data-id="element-555">
              <strong data-id="element-556">Notices.</strong> Any notices or other communications
              provided by Fifth Door under these Terms will be given: (i) via
              email; or (ii) by posting to the Services. For notices made by
              email, the date of receipt will be deemed the date on which such
              notice is transmitted.
            </p>

            <p data-id="element-557">
              <strong data-id="element-558">Waiver of Rights.</strong> Fifth Door's failure to enforce
              any right or provision of these Terms will not be considered a
              waiver of such right or provision. The waiver of any such right or
              provision will be effective only if in writing and signed by a
              duly authorized representative of Fifth Door. Except as expressly
              set forth in these Terms, the exercise by either party of any of
              its remedies under these Terms will be without prejudice to its
              other remedies under these Terms or otherwise.
            </p>

            <p data-id="element-559">
              <strong data-id="element-560">Contact Information.</strong> If you have any questions
              about these Terms or the Services, please contact Fifth Door at
              accounts@fifthdoor.com.
            </p>
          </div>
        </div>
      </main>

      <Footer data-id="element-561" />
    </>;
}